(ns shared.core.loading
  (:require [shared.core.util :as util]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]))

(def spinner-anim (gensym "spinner-anim-"))
(def shimmer-anim (gensym "shimmer-anim-"))

(style/add-keyframes
  spinner-anim
  ["0%" {:transform "rotate(0deg)"}]
  ["100%" {:transform "rotate(360deg)"}])

(style/add-keyframes
  shimmer-anim
  ["0%" {:background-position "100% 0"}]
  ["100%" {:background-position "-100% 0"}])

(defn spinner [_]
  (let [dark?- (re/subscribe [:core/theme-dark?-])]
    (fn [{:keys [class-name color size dark-color border-size style]
          :or {size 16
               border-size 2}}]
      (let [color (if @dark?-
                    (or dark-color (style/dark-color :primary :base))
                    (or color (style/color :green :base)))]
        [:div {:class-name class-name
               :style (merge {:animation (str spinner-anim " 1s ease-in-out infinite")
                              :border (str border-size "px solid " (util/hex->rgba color 0.3))
                              :border-radius "50%"
                              :border-top-color color
                              :display :inline-block
                              :width size
                              :height size}
                             style)}]))))

(defn primary-spinner [args]
  [spinner (assoc args :color (style/color :primary :base))])

(defn spinner-block [_]
  (let [dark?- (re/subscribe [:core/theme-dark?-])]
    (fn [{:keys [spinner-args style]}]
      [:div {:style (merge {:display :flex
                            :align-items :center
                            :justify-content :center
                            :padding 40
                            :width "100%"}
                           style)}
       [spinner (assoc spinner-args :color (or (:color spinner-args)
                                               (if @dark?-
                                                 (style/dark-color :primary :base)
                                                 (style/color :green :base)))
                                    :size (or (:size spinner-args) 25))]])))


(defn loader-rectangle
  [{:keys [width height border-radius style]
    :or {width "100%"
         height 20
         border-radius 12}}]
  [:div
   {:style (merge {:width width
                   :height height
                   :border-radius border-radius
                   :background "linear-gradient(90deg, transparent 25%, rgba(92, 92, 92, 0.13) 50%, transparent 75%)"
                   :background-size "200% 100%"
                   :animation (str shimmer-anim " 1.5s infinite linear")}
                  style)}])